import type { Kks, KksOccurrence } from "@shared/types/domain";

const Y_MARGIN = 5; // mm — items within this vertical range are on the "same line"

/** Build a shareable deep-link URL that opens a KKS occurrence directly in the PID viewer. */
export function buildOccurrenceUrl(
  occ: Pick<KksOccurrence, "plant_id" | "system_id" | "pid_id" | "kks_id">,
  tab: string,
): string {
  const p = new URLSearchParams({
    pp: occ.plant_id,
    sys: occ.system_id,
    pid: occ.pid_id,
    kks: occ.kks_id,
    tab,
  });
  return `${window.location.pathname}?${p.toString()}`;
}

/** Sort items in reading order: page → y (with margin) → x */
export function sortKks(items: Kks[]): Kks[] {
  return [...items].sort((a, b) => {
    const pa = a.page ?? 0;
    const pb = b.page ?? 0;
    if (pa !== pb) return pa - pb;
    const ay = a.bbox ? (a.bbox.y0 + a.bbox.y1) / 2 : 0;
    const by = b.bbox ? (b.bbox.y0 + b.bbox.y1) / 2 : 0;
    if (Math.abs(ay - by) > Y_MARGIN) return ay - by;
    const ax = a.bbox ? a.bbox.x0 : 0;
    const bx = b.bbox ? b.bbox.x0 : 0;
    return ax - bx;
  });
}

export function ensureKksDefaults(kks: Kks): Kks {
  return {
    ...kks,
    required: kks.required ?? false,
    verified: kks.verified ?? false,
    spof: kks.spof ?? false,
    spof_approved: kks.spof_approved ?? false,
    impact: kks.impact ?? 1,
    component: kks.component ?? "Unknown",
    stamp_on_pdf: kks.stamp_on_pdf ?? false,
  };
}

// mm to PDF points (1pt = 25.4/72 mm)
export const MM_TO_PTS = 72.0 / 25.4;
